var A=new Promise((function(A){var n=new Image;n.onerror=function(){return A(!1)},n.onload=function(){return A(1===n.width)},n.src="data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA="})).catch((function(){return!1}));export{A as s};
//# sourceMappingURL=react-bricks-DzZdqeB7.esm.js.map
